import React from 'react';
import { HUB_FOOTER_ID_SELECTOR } from '../../../const/responsive';
import { useHubLayout } from '../../../hooks/useHubLayout';

function Footer() {
  const { footerComponent } = useHubLayout();

  return (
    <footer id={HUB_FOOTER_ID_SELECTOR}>
      {typeof footerComponent === 'function' && footerComponent()}
      {typeof footerComponent === 'object' && footerComponent}
    </footer>
  );
}

export default Footer;
